import styled from 'styled-components';

export const Heading1 = styled.p`
  font-weight: bold;
  font-size: 32px;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.white};
`;

export const Paragraph1 = styled.p`
  font-weight: bold;
  font-size: 16px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.white};
`;

export const Paragraph12 = styled.p`
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.white};
`;

export const Paragraph13 = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: ${({ theme }) => theme.colors.white};
`;
